import { cn } from '@/lib/cn';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'link';
export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon' | 'icon-sm';

const base =
  'inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors ' +
  'focus-visible:outline-none focus-visible:shadow-focus disabled:pointer-events-none disabled:opacity-50';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-primary-fg shadow-xs hover:bg-primary-hover',
  secondary: 'border border-line-strong bg-surface text-ink shadow-xs hover:bg-surface-muted hover:border-ink-muted/50',
  ghost: 'text-ink-secondary hover:bg-surface-sunken hover:text-ink',
  danger: 'bg-danger text-white shadow-xs hover:bg-danger/90',
  link: 'h-auto px-0 text-primary underline-offset-4 hover:underline',
};

const sizes: Record<ButtonSize, string> = {
  sm: 'h-control-sm px-3 text-[13px]',
  md: 'h-control px-4 text-sm',
  lg: 'h-control-lg px-5 text-sm',
  icon: 'h-control w-control p-0',
  'icon-sm': 'h-control-sm w-control-sm p-0',
};

export function buttonClasses(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', className?: string): string {
  return cn(base, variants[variant], variant === 'link' ? 'text-sm' : sizes[size], className);
}
